import { Component, OnInit, ChangeDetectorRef, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { SortDirection, SnackBarMessageType } from "../../shared/contentTypes";
import { LocationViewModel } from "../../shared/models";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { LocationService } from "../../components/location/location.service";

@Component({
  selector: "ya-selectlocationdialog",
  templateUrl: "./selectLocationDialog.component.html",
  styleUrls: ["./selectLocationDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectLocationDialogComponent implements OnInit {

  public locations: LocationViewModel[];
  private sortOption: SortOption[];
  private pagingHelper: PagingHelper;
  constructor(public bottomSheetRef: MatBottomSheetRef<SelectLocationDialogComponent>,
    private _locationService: LocationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _snackBarService: SnackBarService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public menuSettingLocationIds: number[]) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SelectLocationDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.locations = [];
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    me.sortOption.push(me.pagingHelper.createSortOption("like", SortDirection.DESC));
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));

    me.reloadAndRenderData();
  }
  private reloadAndRenderData() {
    const me = this;
    me._locationService.GetLocationViewModel()
      .then((locations) => {
        if (me.menuSettingLocationIds) {
          me.locations.push(...(locations.filter(l => me.menuSettingLocationIds.includes(l.hyp_cus_nr))));
        } else {
          me.locations.push(...locations);
        }
        me.locations.sort(me.pagingHelper.fieldSorter(me.sortOption));
        me.PushChanges();
      })
      .catch(e => {
        this._coreLogService.error("SelectLocationDialogComponent.reloadAndRenderData", "GetLocationViewModel", e);
        me._snackBarService.ShowErrorMessageFailed(113);
      });
  }

  public selectLocation(location: LocationViewModel) {
    const me = this;
    me.bottomSheetRef.dismiss(location.hyp_cus_nr);
  }
}
